/**
 * View Gefahrstoffschulung
 * 
 * Einzelne Gefahrstoffschulung einsehen, bearbeiten oder erstellen
 * 
 */

import { IonAlert, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCheckbox, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonMenuButton, IonPage, IonSelect, IonSelectOption, IonTitle, IonToolbar , useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { Box } from '@mui/material';
import { DataGrid, deDE } from '@mui/x-data-grid';
import axios from 'axios';
import { helpOutline } from 'ionicons/icons';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useGefahrstoffschulungDokumente , useGefahrstoffschulungenThemen, useMitarbeiterListe } from '../components/_CustomHooks';
import { ButtonAdd, ButtonCancelBack, ButtonInaktive , ButtonsSaveActions, defColumn, defColumnRenderCell,  exportTableData, getDokumentDatei , ButtonPageHelp, PageHelp,readableFileSize, SpinnerViewSwitch } from '../components/_HelperFunctions';
import { AppContext } from '../contexts/app_context';

export function Gefahrstoffschulung() {
  useIonViewDidEnter(
    () =>
      {
        appViewSwitchChange( false ) ;  
      }
  ) ;
  const { appArticleId , appBetriebeId , appGefahrstoffschulungDokumenteFetchanewChange , appGefahrstoffschulungDokumente , appGefahrstoffschulungDokumentId , appGefahrstoffschulungDokumentIdChange , appGefahrstoffschulungFetchanew ,appGefahrstoffschulungFetchanewChange ,appGefahrstoffschulungId , appArticleGefahrstoffschulungenFetchanewChange , appArticlesGefahrstoffschulungenThemen , appGefahrstoffschulungIdChange , appGefahrstoffschulungenFetchanewChange , appGefahrstoffschulungenThemen , appGefahrstoffschulungenThemenFetchanewChange , appGefahrstoffschulungenMatrixBuildNewChange , appGefahrstoffschulungNeuTeilnehmer , appGefahrstoffschulungNeuTeilnehmerChange , appGefahrstoffschulungNeuThema , appGefahrstoffschulungNeuThemaChange , appErrorChange , appMitarbeiterListe , appMitarbeiterListeFetchanewChange , appViewSwitch , appViewSwitchChange } = useContext( AppContext ) ;
  const [ pageHelpShow , setPageHelpShow ] = useState( false ) ;
  const screencastChannel = '' ;
  const history = useHistory();
  const [ GefahrstoffschulungenId, setGefahrstoffschulungenId ] = useState( appGefahrstoffschulungId )
  const [ GefahrstoffschulungenBetriebeId, setGefahrstoffschulungenBetriebeId ] = useState( appBetriebeId )
  const [ GefahrstoffschulungenAnmerkungen, setGefahrstoffschulungenAnmerkungen ] = useState( '' )
  const [ GefahrstoffschulungenTermin, setGefahrstoffschulungenTermin ] = useState( '' )
  const [ GefahrstoffschulungenDozent, setGefahrstoffschulungenDozent ] = useState( '' )
  const [ GefahrstoffschulungenThema, setGefahrstoffschulungenThema ] = useState( appGefahrstoffschulungNeuThema )
  const [ GefahrstoffschulungenMitarbeiterId, setGefahrstoffschulungenMitarbeiterId ] = useState( appGefahrstoffschulungNeuTeilnehmer.split(',').filter((e:any)=>e!=='') )
  const [ GefahrstoffschulungenStatus, setGefahrstoffschulungenStatus ] = useState( 'offen' )
  const [ disableEdit, setDisableEdit ] = useState( false )
  const [ addAllMitarbeiter , setAddAllMitarbeiter ] = useState( false ) ;
  /** ! "lastAddedMitarbeiter" auch als Trigger, damit Ionic re-rendert */
    const [ lastAddedMitarbeiter , setLastAddedMitarbeiter ] = useState( '' ) ;
  /** ! "anzahlTeilnehmer" auch als Trigger, damit Ionic re-rendert */
    const [ anzahlTeilnehmer , setAnzahlTeilnehmer ] = useState( appGefahrstoffschulungNeuTeilnehmer.split(',').filter((e:any)=>e!=='').length ) ;
    const [ tableData , settableData ] = useState( Array() ) ;
    //#region Dialog-Dokument
    const [ localGefahrstoffschulungDokumente , localGefahrstoffschulungDokumenteChange ] = useState( Array() ) ;
    const [ existInaktive , setExistInaktive ] = useState( false ) ;
    const [ showInaktive , setShowInaktive ] = useState( false ) ;
      /** Eintrag bearbeiten vs. Dokument herunterladen */
    const [ dokumentToActOn , setDokumentToActOn ] = useState( '' ) ;
      //#endregion Dialog-Dokument
  //#region Listen-DataGrids für Attachments
    const [pageSize, setPageSize] = useState(10);
      //#endregion Listen-DataGrids für Attachments

  const mkMyGefahrstoffschulungenThemen = ( generalList:any ) =>
    {
      let myList = 
        generalList
          .filter(
            ( entry:any ) => entry.SchulungenAktiv === 'aktiv'
          )
          .filter(
            ( entry:any ) => entry.SchulungenId !== GefahrstoffschulungenThema
          )
      if( appArticleId !== 'neu' ) {
        myList =
          myList
            .filter(
              ( entry:any ) =>
                  appArticlesGefahrstoffschulungenThemen
                    .findIndex(
                      ( themen:any ) =>
                        themen.article === appArticleId
                        &&
                        themen.id === entry.SchulungenId
                    ) > -1
            )
      }
      return myList ;
    }

  const getDataGefahrstoffschulungen = () => {
    if (appGefahrstoffschulungId === 'neu') {
      setGefahrstoffschulungenId( 'neu' ) ;
      setGefahrstoffschulungenBetriebeId( appBetriebeId ) ;
      setGefahrstoffschulungenThema( appGefahrstoffschulungNeuThema ) ;
      setGefahrstoffschulungenMitarbeiterId( appGefahrstoffschulungNeuTeilnehmer.split(',').filter((e:any)=>e!=='') ) ;
      setAnzahlTeilnehmer( appGefahrstoffschulungNeuTeilnehmer.split(',').filter((e:any)=>e!=='').length ) ;
      setGefahrstoffschulungenTermin( '' ) ;
      setGefahrstoffschulungenAnmerkungen( '' ) ;
      setGefahrstoffschulungenDozent( '' ) ;
      setGefahrstoffschulungenStatus( 'offen' ) ;
    } else {
      const api = axios.create({
        baseURL: `https://datamehr-backend.saint-online.de/api/gefahrstoffschulungen/get_gefahrstoffschulung.php?gefahrstoffschulungen_id=` + appGefahrstoffschulungId ,
        headers: {
          'Accept': 'application/json',
          Authorization: `Bearer ${ window.localStorage.getItem('jwt') }`,
        },
      });
      api.get( "" )
      .then((res) => {
        let data = res.data;
        data.forEach((gefahrstoffschulungen: any) => {
          if (gefahrstoffschulungen.GefahrstoffschulungenId === GefahrstoffschulungenId) {
            setGefahrstoffschulungenId( gefahrstoffschulungen.GefahrstoffschulungenId ) ;
            setGefahrstoffschulungenBetriebeId( gefahrstoffschulungen.GefahrstoffschulungenBetriebeId ) ;
            setGefahrstoffschulungenThema( gefahrstoffschulungen.GefahrstoffschulungenThema ) ;
            let myGefahrstoffschulungenMitarbeiterId = gefahrstoffschulungen.GefahrstoffschulungenMitarbeiterId.split(',').filter((e:any)=>e!=='') ;
            setGefahrstoffschulungenMitarbeiterId( myGefahrstoffschulungenMitarbeiterId ) ;
            setAnzahlTeilnehmer( myGefahrstoffschulungenMitarbeiterId.length ) ;
            setGefahrstoffschulungenTermin( gefahrstoffschulungen.GefahrstoffschulungenTermin ) ;
            setGefahrstoffschulungenAnmerkungen( gefahrstoffschulungen.GefahrstoffschulungenAnmerkungen ) ;
            setGefahrstoffschulungenDozent( gefahrstoffschulungen.GefahrstoffschulungenDozent ) ;
            setGefahrstoffschulungenStatus( gefahrstoffschulungen.GefahrstoffschulungenStatus ) ;
            if( gefahrstoffschulungen.GefahrstoffschulungenStatus === 'abgeschlossen' ) {
              setDisableEdit( true ) ;
            }
          }
        })
      });
    }
  }
  async function sendJSON() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append( 'Authorization' , `Bearer ${ window.localStorage.getItem('jwt') }` ) ;
    var raw = JSON.stringify({
      GefahrstoffschulungenId: GefahrstoffschulungenId ,
      GefahrstoffschulungenBetriebeId: GefahrstoffschulungenBetriebeId ,
      GefahrstoffschulungenThema: GefahrstoffschulungenThema || ' ',
      GefahrstoffschulungenMitarbeiterId: GefahrstoffschulungenMitarbeiterId.toString() || '' ,
      GefahrstoffschulungenTermin: GefahrstoffschulungenTermin || '0000-00-00' ,
      GefahrstoffschulungenAnmerkungen: GefahrstoffschulungenAnmerkungen || '' ,
      GefahrstoffschulungenDozent: GefahrstoffschulungenDozent || '' ,
      GefahrstoffschulungenStatus: GefahrstoffschulungenStatus
    });
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
    };
    await fetch('https://datamehr-backend.saint-online.de/api/gefahrstoffschulungen/set_gefahrstoffschulung.php', requestOptions)
    .then( response => response.json() )
    .then(
      json =>
        {
          if( json.entryId > 0 ) {
            appGefahrstoffschulungIdChange( json.entryId ) ;
          }
        }
      )
    appGefahrstoffschulungNeuTeilnehmerChange( '') ;
    appGefahrstoffschulungNeuThemaChange( '' ) ;
    appGefahrstoffschulungFetchanewChange( true ) ;
    appGefahrstoffschulungenFetchanewChange( true ) ;
    appArticleGefahrstoffschulungenFetchanewChange( true ) ;
  }
  //#region chkFieldData
    /** field:string , shouldNotBe:any
     * @param fieldsAndVals   Array aus Arrays: zu prüfende Felder
     *                          - Array pro zu prüfendes Feld: [ feldTitel , feldShouldNotBe , feldVal ]
     *                            - z.B. [ 'Termin' , '' , GefahrstoffschulungenTermin ]
     *                          - ggf. pro Feld mehrere Prüf-Anweisungen
     *                                
     */
      const chkFieldData = ( fieldsAndVals:any ) =>
        {
          let stopMessage = '' ;
          fieldsAndVals.forEach(
            ( entry:any ) =>
              {
                if( entry[ 1 ] === entry[ 2 ] ) {
                  let valAttribute = ( entry[ 1 ] !== '' ) ? 'gültigen ' : '' ;
                  stopMessage += '\n\n- Feld "' + entry[ 0 ] + '"\n      Bitte geben Sie einen ' + valAttribute + 'Wert ein' ;
                }
              }
          );
          if( stopMessage ) {
            appErrorChange( 'Gefahrstoffschulung ' + appGefahrstoffschulungId + ': ungültige oder fehlende Eingaben' ) ;
            alert( '\nEingaben können nicht verarbeitet werden:' +  stopMessage ) ;
            return false ;
          }
          else {
            appErrorChange( '' ) ;
            return true ;
          }

        }
      //#endregion chkFieldData
  function onValueGefahrstoffschulungenThema( e:any ) { setGefahrstoffschulungenThema( e.target.value ) ; }
  function onValueGefahrstoffschulungenStatus( e:any ) { setGefahrstoffschulungenStatus( e.target.value ) ; }
  function onValueTeilnehmerListe( mitarbeiterId:any ) { 
    let myGefahrstoffschulungenMitarbeiterId = GefahrstoffschulungenMitarbeiterId ;
    if( mitarbeiterId === 'alle' ) {
      myGefahrstoffschulungenMitarbeiterId = [] ;
      setLastAddedMitarbeiter( '' ) ;
    } else {
      myGefahrstoffschulungenMitarbeiterId = myGefahrstoffschulungenMitarbeiterId.filter( ( entry:any ) => entry !== mitarbeiterId ) ;
    }
    setGefahrstoffschulungenMitarbeiterId( myGefahrstoffschulungenMitarbeiterId ) ;
    setAnzahlTeilnehmer( myGefahrstoffschulungenMitarbeiterId.length ) ;
    setAddAllMitarbeiter( false ) ;
  }
  function onValueTeilnehmerDazu( mitarbeiterId:any , mitarbeiterName:string ) { 
    let myGefahrstoffschulungenMitarbeiterId = GefahrstoffschulungenMitarbeiterId ;
    if( mitarbeiterId === 'alle' ) {
      setAddAllMitarbeiter( true ) ;
    } else {
      /** vermutlich wg. State / Rerender wird die Anweisung hier mehrfach durchlaufen, deshalb Check auf "schon gesetzt" */
        if( ! myGefahrstoffschulungenMitarbeiterId.includes( mitarbeiterId ) ) {
          myGefahrstoffschulungenMitarbeiterId.push( mitarbeiterId ) ;
        }
        setLastAddedMitarbeiter( mitarbeiterName ) ;
    }
    setGefahrstoffschulungenMitarbeiterId( myGefahrstoffschulungenMitarbeiterId ) ;
    setAnzahlTeilnehmer( myGefahrstoffschulungenMitarbeiterId.length ) ;
  }
  function onValueGefahrstoffschulungenTermin( e:any ) { setGefahrstoffschulungenTermin( e.target.value ) ; }
    // "Thema"-Dropdown aus Gefahrstoffschulungsthemen-DB (Einstellungen)
  useGefahrstoffschulungenThemen() ;

  const handleInaktive = () =>
    {
      if( showInaktive ) {
        localGefahrstoffschulungDokumenteChange( appGefahrstoffschulungDokumente )
      }
      else {
        localGefahrstoffschulungDokumenteChange(
          appGefahrstoffschulungDokumente
            .filter(
              ( entry:any ) => entry.DokumenteAktiv === 'aktiv'
            )        
        )
      }
    }

  useEffect(
    () => {
      if( appGefahrstoffschulungDokumente
          .findIndex(
            ( entry:any ) => entry.DokumenteAktiv === 'inaktiv'
          ) > -1
      )
        {
          setExistInaktive( true )
        }
      else
        {
          setExistInaktive( false )
        }
      handleInaktive() ;
    } ,
    [ appGefahrstoffschulungDokumente ]
  )
  
  useEffect(
    () => {
      handleInaktive() ;
    } ,
    [ showInaktive ]
  )
  
    // "Teilnehmer"-Dropdown aus Mitarbeiter-DB (Einstellungen)
  useMitarbeiterListe() ;
    // "Dokumente"-Liste
  useGefahrstoffschulungDokumente() ;
  useEffect(
    () => {
       setGefahrstoffschulungenId( appGefahrstoffschulungId ) ;
       appGefahrstoffschulungFetchanewChange( true ) ;
       appGefahrstoffschulungDokumenteFetchanewChange( true ) 
    },
    [ appGefahrstoffschulungId ]
  ) ;
  useEffect(
    () => {
      if( appGefahrstoffschulungFetchanew ) {
        appGefahrstoffschulungFetchanewChange( false ) ;
        if( appGefahrstoffschulungId !== 'neu' ) {
          appGefahrstoffschulungDokumenteFetchanewChange( true ) ;
          appGefahrstoffschulungenThemenFetchanewChange( true ) ;
          appMitarbeiterListeFetchanewChange( true ) ;
        }
        getDataGefahrstoffschulungen() ;
      }
    },
    [ appGefahrstoffschulungFetchanew ]
  ) ;
  function onValueGefahrstoffschulungenDozent(e: any) {
    setGefahrstoffschulungenDozent(e.target.value); 
  }
  function onValueGefahrstoffschulungenAnmerkungen(e: any) {
    setGefahrstoffschulungenAnmerkungen(e.target.value); 
  }
  const getInhaltForGefahrstoffschulungsThema = ( themaId:any ) =>
    {
      let themaMatch = appGefahrstoffschulungenThemen
        .find(
          ( thema:any ) => thema.SchulungenId === themaId
      )
      if( themaMatch ) {
        return themaMatch.SchulungenInhalt ;
      }
    }
  const getTitleForGefahrstoffschulungsThema = ( themaId:any ) =>
    {
      // themaId = 1135516
      // console.log( 'check' , themaId , 'in' , appGefahrstoffschulungenThemen ) ;
      let themaMatch = appGefahrstoffschulungenThemen
        .find(
          ( thema:any ) => thema.SchulungenId === themaId
      )
      // console.log( themaMatch ) ;
      if( themaMatch ) {
        return '"' + themaMatch.SchulungenTitel + '"' ;
      }
      else {
        return '' ;
      }
    }
  return (
    <IonPage>
      <SpinnerViewSwitch />
      <PageHelp page = { screencastChannel }  state = { pageHelpShow } set = { setPageHelpShow } >
        <p>
           Auf dieser Seite können Sie Details für eine Gefahrstoffschulung einsehen und bearbeiten oder für eine neue Gefahrstoffschulung festlegen.
        </p>
      </PageHelp>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle slot=""  >
              Gefahrstoffschulung { ' ' }
              {
                GefahrstoffschulungenId === 'neu'
                  ?
                    '(neu)'
                  :
                     getTitleForGefahrstoffschulungsThema( GefahrstoffschulungenThema )
              }
              {
                GefahrstoffschulungenId !== 'neu'
                  ?
                    GefahrstoffschulungenTermin !== '0000-00-00'
                      ?
                        ' Termin ' + new Date( GefahrstoffschulungenTermin ).toLocaleDateString()
                      :
                        ' Termin offen'
                  :
                    ''
              }
          </IonTitle>
          <ButtonPageHelp page = { screencastChannel } state = { pageHelpShow } set = { setPageHelpShow } />
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonCard>
          <IonCardHeader>
          </IonCardHeader>
          <IonCardContent>
          <IonItem className='item'>
              <IonLabel position="stacked">Thema</IonLabel>
              <IonSelect disabled = { disableEdit } cancelText="Abbrechen" interface = 'action-sheet' value={ GefahrstoffschulungenThema } onIonChange={ ( e )=> onValueGefahrstoffschulungenThema( e ) } >
                { GefahrstoffschulungenThema
                    ? 
                      appGefahrstoffschulungenThemen
                        .filter(
                          ( { SchulungenId }:any ) => SchulungenId === GefahrstoffschulungenThema 
                        )
                        .map(
                          ( entry:any ) =>
                            {
                              let disabled = false ;
                              let disabledNote = '' ;
                              if( entry.SchulungenAktiv !== 'aktiv' )
                                {
                                  disabled = true ;
                                  disabledNote = ' (inaktiv )' ;
                                }
                                return <IonSelectOption key = { entry.SchulungenTitel + entry.SchulungenId } disabled = { disabled } value = { entry.SchulungenId } >{ entry.SchulungenTitel + disabledNote }</IonSelectOption>
                              }
                        )
                    : 
                      ''
                }
                {
                  mkMyGefahrstoffschulungenThemen( appGefahrstoffschulungenThemen )
                  .map(
                      ( entry:any ) =>
                        {
                          return <IonSelectOption key = { entry.SchulungenTitel + entry.SchulungenId } value = { entry.SchulungenId } >{ entry.SchulungenTitel }</IonSelectOption>
                        }
                    )
                }
              </IonSelect>
          </IonItem>
          <IonItem>
              <IonLabel position="stacked">Inhalt</IonLabel>
              <div>
                { getInhaltForGefahrstoffschulungsThema( GefahrstoffschulungenThema ) }
              </div>
            </IonItem>
          <IonItem>
            <IonLabel position="stacked">Anmerkungen</IonLabel>
            <IonInput disabled = { disableEdit } required value = { GefahrstoffschulungenAnmerkungen } onIonChange = { ( e ) => onValueGefahrstoffschulungenAnmerkungen( e ) } />
          </IonItem>
          <IonItem>
              <IonLabel position="stacked">Status</IonLabel>
              <IonSelect disabled = { disableEdit } cancelText="Abbrechen" interface = 'action-sheet' placeholder="bitte auswählen" value={ GefahrstoffschulungenStatus } onIonChange={ ( e )=> onValueGefahrstoffschulungenStatus( e ) } >
                <IonSelectOption key = { 'offen' } value = { 'offen' } >offen</IonSelectOption>
                <IonSelectOption key = { 'abgeschlossen' } value = { 'abgeschlossen' } >abgeschlossen</IonSelectOption>
              </IonSelect>
            </IonItem>
            <IonItem>
              <IonLabel position="stacked">Termin</IonLabel>
              <IonInput disabled = { disableEdit } type="date" placeholder="bitte auswählen" required value={ GefahrstoffschulungenTermin }  onIonChange={(e) => onValueGefahrstoffschulungenTermin(e)}/>
            </IonItem>
            <IonItem className='item'>
              <IonLabel position="stacked">Dozent/in</IonLabel>
              <IonInput disabled = { disableEdit } required value = { GefahrstoffschulungenDozent } onIonChange = { ( e ) => onValueGefahrstoffschulungenDozent( e ) } />
            </IonItem>
            <IonItem className='item'>
              <IonLabel position="stacked">Teilnehmerliste ( { anzahlTeilnehmer } Teilnehmer)</IonLabel>
              <div style={ { height: '200px' , overflowY: 'scroll' , width: '100%' } }>
                {
                  ( GefahrstoffschulungenMitarbeiterId.length > 0 && ! disableEdit )
                    ?
                      <IonItem lines="none" className='item'>
                        <IonLabel slot="">alle entfernen</IonLabel>
                        <IonCheckbox disabled = { disableEdit } slot="start" key = 'alle' checked={ false } onIonChange={() => onValueTeilnehmerListe( 'alle' ) } />
                      </IonItem>
                    :
                      ''
                }
                {
                  appMitarbeiterListe
                    .filter(
                        ( entry:any ) => GefahrstoffschulungenMitarbeiterId.includes( entry.MitarbeiterId )
                    )
                    .map(
                      ( entry:any ) =>
                          {
                            /* !!! Für "neu" inaktive Mitarbeiter ausblenden, für existierende Gefahrstoffschulungen als inaktiv markieren */
                              let disabledNote = '' ;
                              if( entry.MitarbeiterAktiv === 'inaktiv' )
                                {
                                  if( GefahrstoffschulungenStatus === 'abgeschlossen' ) {
                                    disabledNote = ' (inaktiv )' ;
                                  } else {
                                    return '' ;
                                  }
                                }
                            // return <IonSelectOption key = { entry.MitarbeiterId } value = { entry.MitarbeiterId } >{ entry.MitarbeiterNachname + ' PN ' + entry.MitarbeiterPersonalnummer + disabledNote }</IonSelectOption>
                            return (
                              <IonItem lines="none" className='item'>
                                <IonLabel slot="">{ entry.MitarbeiterNachname + ' PN ' + entry.MitarbeiterPersonalnummer + disabledNote }</IonLabel>
                                <IonCheckbox disabled = { disableEdit } slot="start" key = { entry.MitarbeiterId + '_onList' } checked={ anzahlTeilnehmer > 0 ? true : false } onIonChange={() => onValueTeilnehmerListe( entry.MitarbeiterId ) } />
                              </IonItem>
                            )
                          }
                      )
                  }
              </div>
            </IonItem>
            {
               disableEdit
                ?
                  ''
                :
                  <IonItem className='item'>
                      <IonLabel position="stacked">Teilnehmer hinzufügen { lastAddedMitarbeiter !== '' ? '(zuletzt hinzugefügt:' + lastAddedMitarbeiter + ')' : '' }</IonLabel>
                        <div style={ { height: '200px' , overflowY: 'scroll' , width: '100%' } }>
                          {
                            ! addAllMitarbeiter
                              ?
                                <IonItem lines="none" className='item'>
                                  <IonLabel slot="">alle hinzufügen</IonLabel>
                                  <IonCheckbox disabled = { disableEdit } slot="start" key = 'alle' checked={ false } onIonChange={() => onValueTeilnehmerDazu( 'alle' , '' ) } />
                                </IonItem>
                              :
                                ''
                          }
                          {
                            appMitarbeiterListe
                            .filter(
                              ( entry:any ) => ! GefahrstoffschulungenMitarbeiterId.includes( entry.MitarbeiterId )
                            )
                            .map(
                              ( entry:any ) =>
                                  {
                                    /* !!! Für "neu" inaktive Mitarbeiter ausblenden, für existierende Gefahrstoffschulungen als inaktiv markieren */
                                      let disabledNote = '' ;
                                      if( entry.MitarbeiterAktiv === 'inaktiv' )
                                        {
                                          if( GefahrstoffschulungenStatus === 'abgeschlossen' ) {
                                            disabledNote = ' (inaktiv )' ;
                                          } else {
                                            return '' ;
                                          }
                                        }
                                    // return <IonSelectOption key = { entry.MitarbeiterId } value = { entry.MitarbeiterId } >{ entry.MitarbeiterNachname + ' PN ' + entry.MitarbeiterPersonalnummer + disabledNote }</IonSelectOption>
                                    return (
                                      <IonItem lines="none" className='item'>
                                        <IonLabel slot="">{ entry.MitarbeiterNachname + ' PN ' + entry.MitarbeiterPersonalnummer + disabledNote }</IonLabel>
                                        <IonCheckbox disabled = { disableEdit } slot="start" key = { entry.MitarbeiterId + '_offList' } checked={ addAllMitarbeiter } onIonChange={() => onValueTeilnehmerDazu( entry.MitarbeiterId , entry.MitarbeiterNachname + ' PN ' + entry.MitarbeiterPersonalnummer ) } />
                                      </IonItem>
                                    )
                                  }
                              )
                          }
                        </div>
                  </IonItem>
            }
          </IonCardContent>
        </IonCard>
        <IonCard>
          <IonCardContent>
            {
              ! disableEdit
                ?
                  <>
                    <ButtonsSaveActions
                      myExec = {
                        () =>
                          {
                            if(
                              chkFieldData(
                                [
                                  [ 'Thema' , '' , GefahrstoffschulungenThema ]  ,
                                  [ 'Termin' , '' , GefahrstoffschulungenTermin ]
                                ]
                              )
                            )
                              {
                                sendJSON() ; }
                            else
                              {
                                return false ;
                              }
                          }
                      }
                    />
                      {
                        appGefahrstoffschulungId !== 'neu'
                          ?
                            <IonButton
                              onClick = {
                                () => 
                                  { 
                                    sendJSON() ;
                                    window.open( 'https://datamehr-backend.saint-online.de/api/gefahrstoffschulungen/print_gefahrstoffschulung_unterschriftenliste.php?gefahrstoffschulungen_id=' + appGefahrstoffschulungId )
                                  } 
                              }
                            >
                              Unterschriftenliste
                            </IonButton>
                          :
                            ''
                      }
                  </>
                :
                  ''
            }
            <ButtonCancelBack label = 'Abbrechen' myExec = { () => { appGefahrstoffschulungNeuTeilnehmerChange( '') ; appGefahrstoffschulungNeuThemaChange( '' ) ; } } />
          </IonCardContent>
        </IonCard>
        {
            appGefahrstoffschulungId !== 'neu'
              ?
                <IonCard class="Dokumente">
                  <IonAlert
                    isOpen = { dokumentToActOn ? true : false }
                    backdropDismiss = { true }
                    header = 'Gewählte Datei ...'
                    message = ''
                    buttons = {
                      [
                        {
                          text: 'Herunterladen' ,
                          handler: () => {
                            getDokumentDatei( dokumentToActOn ) ;
                            setDokumentToActOn( '' ) ;
                          }
                        } ,
                        {
                          text: 'Listeneintrag bearbeiten' ,
                          handler: () => {
                            appViewSwitchChange( true ) ;
                            appGefahrstoffschulungDokumentIdChange( dokumentToActOn ) ;
                            history.push( '/dokument-gefahrstoffschulung/' + dokumentToActOn + '/' + appGefahrstoffschulungId )
                            setDokumentToActOn( '' ) ;
                          }
                        } ,
                        {
                          text: 'Abbrechen' ,
                          handler: () => {
                            setDokumentToActOn( '' ) ;
                          }
                        }
                      ]
                    }
                  />
                  <IonCardHeader>
                    <IonCardTitle>Dokumente</IonCardTitle>
                  </IonCardHeader>
                  {
                    appGefahrstoffschulungDokumente.length > 0
                      ?
                        <Box width="100vh"
                          sx={{
                            height: 300,
                            width: 1,
                            "& .super-app-theme--header": {
                              backgroundColor: "rgb(211,211,211)",
                            },
                          }}
                        >
                          <DataGrid
                            disableVirtualization 
                            initialState={{
                              sorting: {
                                sortModel: [ { field: 'DokumenteDateidatum' , sort: 'desc' } ] ,
                              },
                            }}
                            getRowId={(row) => row.DokumenteId}
                            getRowClassName =
                            {
                              ( data:any ) => data.row.DokumenteAktiv === 'inaktiv' ? 'eintrag_inaktiv' : ''
                            }
                            rows = { localGefahrstoffschulungDokumente }
                            columns = {
                              [
                                defColumn( "DokumenteId" , "Id" , 0 ) ,
                                defColumnRenderCell(
                                  defColumn( "DokumenteDateidatum" , "Datum" , 150 , 0 ) ,
                                  ( data:any ) =>
                                    new Date( data.row.DokumenteDateidatum ).toLocaleString()
                                ) ,
                                defColumn( "DokumenteThema" , "Bezeichnung" , 300 ) ,
                                defColumnRenderCell(
                                  defColumn( "DokumenteDateigroesse" , "Größe" , 80 , 1 , 80 ) ,
                                  ( data:any ) =>
                                    readableFileSize( parseInt( data.row.DokumenteDateigroesse , 10 ) )
                                ) ,
                                defColumn( "DokumenteDateiname" , "Dateiname" , 300 )
                              ]
                            } 
                            pageSize={pageSize}
                            rowsPerPageOptions={[10,50,100]}
                            disableSelectionOnClick
                            onCellClick =
                              {
                                ( e:any ) =>
                                  {
                                    /** Browser / Web vs. App nativ */
                                    if( navigator ) {
                                      setDokumentToActOn( e.id ) ;
                                    } else {
                                      appGefahrstoffschulungDokumentIdChange( e.id ) ;
                                      appViewSwitchChange( true ) ;
                                      history.push( '/dokument-gefahrstoffschulung/' + e.id + '/' + appGefahrstoffschulungId )
                                    }
                                  }
                              }
                            sortingOrder={["desc", "asc"]}
                            onPageSizeChange={(newPage) => setPageSize(newPage)}
                            pagination
                            localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                          />
                        </Box>
                      :
                        ""
                  }
                  <ButtonInaktive
                    disabled = { existInaktive ? false : true }
                    myExec = {
                      () =>
                        {
                          setShowInaktive( showInaktive ? false : true )
                        }
                    }
                    label = { showInaktive ? 'Inaktive ausblenden' : 'Inaktive anzeigen' }
                  />
                  <ButtonAdd
                    myExec = { () => { appGefahrstoffschulungDokumentIdChange( 'neu' ) ; } }
                    routeUrl = { '/dokument-gefahrstoffschulung/neu/' + appGefahrstoffschulungId }
                  />
                  {
                    tableData.length > 0
                      ?
                        <IonButton onClick={ () => exportTableData( appGefahrstoffschulungDokumente , 'Dokumente Gefahrstoffschulung ' + appGefahrstoffschulungId ) }>Exportieren</IonButton>
                      :
                        ''
                  }
                </IonCard>
              :
                ''
          }
      </IonContent>
    </IonPage>
  );
};

